exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CampaignConnectChannelModal .PlatformIcon__wrapper {\n  border-radius: 50%;\n  width: 100px;\n  height: 100px;\n  padding: 20px;\n  text-align: center;\n  border: 2px solid #d6e2eb;\n  margin: auto;\n}\n.CampaignConnectChannelModal .PlatformIcon {\n  font-size: 60px;\n}\n", ""]);

// exports
